var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavoriteOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.35742 0.891602C8.61891 0.369417 9.38111 0.369411 9.64258 0.891602L11.7646 5.13281L11.8818 5.36719L12.1416 5.4043L16.8877 6.08398C17.4818 6.16938 17.6988 6.87577 17.2852 7.27344L13.8506 10.5742L13.6592 10.7588L13.7051 11.0205L14.5156 15.6816C14.6122 16.2373 14.0139 16.6947 13.4756 16.416L9.23047 14.2148L9 14.0957L8.76953 14.2148L4.52441 16.416C3.98606 16.6947 3.38774 16.2373 3.48438 15.6816L4.29492 11.0205L4.34082 10.7588L4.14941 10.5742L0.714844 7.27344C0.301177 6.8758 0.51815 6.16939 1.1123 6.08398L5.8584 5.4043L6.11816 5.36719L6.23535 5.13281L8.35742 0.891602Z",
    fill: "white",
    stroke: "#959595"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteOff);
export default __webpack_public_path__ + "static/media/FavoriteOff.bb776064f2dfe1c586cb0390dcf5f523.svg";
export { ForwardRef as ReactComponent };